//Widgets.tsx ==============================================================
import "../Util/Prototypes";

import * as AdvancedSearch from "../Search/AdvancedSearch";
import * as AgriculturalUse from "./AgriculturalUse";
import * as BasemapGallery from "./BasemapGallery";
import * as Bookmarks from "./Bookmarks";
import * as CommunityInfo from "./CommunityInfo";
import * as CompareMaps from "./CompareMaps";
import * as Default from "../Default";
import * as DrawerMenu from "../Menus/DrawerMenu";
//import * as ExportMap from "./ExportMap";
import * as Legend from "./Legend";
import * as MainMap from "../MainMap";
import * as MapLayers from "./MapLayers";
import * as MapThemes from "./MapThemes";
import * as Measure from "./Measure";
import * as ParcelSymbol from "../Util/ParcelSymbol";
import * as PrevNextExtent from "../Menus/PrevNextExtent";
import * as PrintUI from "../Print/PrintUI";
import * as PrintAddressChangeUI from "../Print Address Change/PrintAddressChangeUI"; /*CUSTOM! Poway*/
import * as QuickSearch from "../Search/QuickSearch";
import * as SalesResults from "../Sales Search/SalesResults";
import * as SalesSearch from "../Sales Search/SalesSearch";
import * as Search from "../Search/Search";
import * as SearchResults from "../Search/SearchResults";
import * as SelectOnMap from "../Search/SelectOnMap";
import * as Settings from "../Settings";
import * as Sketch from "./Sketch";
import * as Util from "../Util/Util";
import * as Util_App from "../Util/Util_App"; /*CUSTOM! Poway*/
import * as WebMaps from "./WebMaps";
import * as Widgets from "./Widgets";

import { CssBaseline, Fade, Zoom } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";

import React from "react";
import ReactDOM from "react-dom/client";

import Attribution from "@arcgis/core/widgets/Attribution";
import BasemapToggle from "@arcgis/core/widgets/BasemapToggle";
import Compass from "@arcgis/core/widgets/Compass";
import Home from "@arcgis/core/widgets/Home";
import Track from "@arcgis/core/widgets/Track";
import * as reactiveUtils from "@arcgis/core/core/reactiveUtils";
import ScaleBar from "@arcgis/core/widgets/ScaleBar";
import Viewpoint from "@arcgis/core/Viewpoint";

let _track: __esri.Track;
let _home: __esri.Home;
let _compass: __esri.Compass;
let _scaleBar: __esri.ScaleBar;
let basemapToggle: __esri.BasemapToggle;
let coordWidget: __esri.CoordinateConversion;
let attribution: __esri.Attribution = null;

let advancedSearchVisible: boolean;
let agriculturalUseVisible: boolean;
let basemapGalleryVisible: boolean;
let bookmarksVisible: boolean;
let communityInfoVisible: boolean;
let compareMapsVisible: boolean;
let exportMapVisible: boolean;
let legendVisible: boolean;
let mapLayersVisible: boolean;
let mapThemesVisible: boolean;
let measureVisible: boolean;
let printVisible: boolean;
let printAddressChangeVisible: boolean; //CUSTOM! Poway
let salesResultsVisible: boolean;
let salesSearchVisible: boolean;
let searchResultsVisible: boolean;
let searchVisible: boolean;
let selectOnMapVisible: boolean;
let sketchVisible: boolean;
let webMapsVisible: boolean;
let root: ReactDOM.Root;

//Show left panel widget.
export function show(toolName: string) {
   Util.logMsg("Building react component for: " + toolName);

   if (!root) {
      root = ReactDOM.createRoot(document.getElementById("widgetsDiv"));
   }
   root.render(<Render toolName={toolName} />);
}

interface iProps {
   toolName: string;
}

//Render function.
export function Render(props: iProps) {
   //Util.logMsg("Top of Widgets Render");
   const toolName: string = props.toolName;

   //Component did mount.
   React.useEffect(() => {
   }, []);

   //Component did update.
   React.useEffect(() => {
      Widgets.setPosition(); //Set the position of the active tool.

      // Added in 4.21 for phone refresh bug.
      if (Settings.isPhone) {
         setTimeout(function () { Widgets.setPosition(); }, 500);
      }
   });

   //Set visibility.
   advancedSearchVisible = false;
   agriculturalUseVisible = false;
   basemapGalleryVisible = false;
   bookmarksVisible = false;
   communityInfoVisible = false;
   compareMapsVisible = false;
   exportMapVisible = false;
   legendVisible = false;
   mapLayersVisible = false;
   mapThemesVisible = false;
   measureVisible = false;
   printVisible = false;
   printAddressChangeVisible = false; //CUSTOM! Poway
   salesResultsVisible = false;
   salesSearchVisible = false;
   searchResultsVisible = false;
   searchVisible = false;
   selectOnMapVisible = false;
   sketchVisible = false;
   webMapsVisible = false;

   if (toolName === "Advanced Search") {
      advancedSearchVisible = true;

   } else if (toolName === "Agricultural Use") {
      agriculturalUseVisible = true;

   } else if (toolName === "Basemap Gallery") {
      basemapGalleryVisible = true;

   } else if (toolName === "Bookmarks") {
      bookmarksVisible = true;

   } else if (toolName === "Community Information") {
      communityInfoVisible = true;

   } else if (toolName === "Compare Maps") {
      compareMapsVisible = true;

   } else if (toolName === "Export Map") {
      exportMapVisible = true;

   } else if (toolName === "Legend") {
      legendVisible = true;

   } else if (toolName === "Map Layers") {
      mapLayersVisible = true;

   } else if (toolName === "Map Themes") {
      mapThemesVisible = true;

   } else if (toolName === "Measure") {
      measureVisible = true;

   } else if (toolName === "Print") {
      printVisible = true;

   //CUSTOM! Poway
   } else if (toolName === "Print Address Change") {
      printAddressChangeVisible = true;

   } else if (toolName === "Search Results") {
      searchResultsVisible = true;

   } else if (toolName === "Quick Search") {
      searchVisible = true;

   } else if (toolName === "Sales Results") {
      salesResultsVisible = true;

   } else if (toolName === "Sales Search") {
      salesSearchVisible = true;

   } else if (toolName === "Select on Map") {
      selectOnMapVisible = true;

   } else if (toolName === "Sketch") {
      sketchVisible = true;

   } else if (toolName === "Web Maps") {
      webMapsVisible = true;
   }

   const delay: number = 450;

   //Styles.
   const styles: Default.iStyles = {
      appWidgetDiv: { position: 'absolute', top: 0, left: 0, zIndex: 3, minWidth: Settings.leftPanelWidth, overflow: 'auto' },
   };

   // More properties: https://reactcommunity.org/react-transition-group/transition#Transition-props
   // Note ! Util.uid is required for printing a widget.

   return (
      <ThemeProvider theme={Default.theme}>
         <CssBaseline />

         <Zoom in={advancedSearchVisible} timeout={delay} mountOnEnter unmountOnExit>
            <div id="Advanced_Search_Widget" style={styles.appWidgetDiv}>
               <AdvancedSearch.Render />
            </div>
         </Zoom>

         <Zoom in={agriculturalUseVisible} timeout={delay} mountOnEnter unmountOnExit>
            <div id="Agricultural_Use_Widget" style={styles.appWidgetDiv}>
               <AgriculturalUse.Render />
            </div>
         </Zoom>

         <BasemapGallery.Render fadeIn={basemapGalleryVisible} />

         <Zoom in={bookmarksVisible} timeout={delay} mountOnEnter unmountOnExit>
            <div id="Bookmarks_Widget" style={styles.appWidgetDiv}>
               <Bookmarks.Render />
            </div>
         </Zoom>

         <Zoom in={communityInfoVisible} timeout={delay} mountOnEnter unmountOnExit>
            <div id="Community_Information_Widget" style={styles.appWidgetDiv}>
               <CommunityInfo.Render />
            </div>
         </Zoom>

         <Zoom in={compareMapsVisible} timeout={delay} mountOnEnter unmountOnExit>
            <div id="Compare_Maps_Widget" style={styles.appWidgetDiv}>
               <CompareMaps.Render />
            </div>
         </Zoom>

         {/*<Zoom in={exportMapVisible} timeout={delay} mountOnEnter unmountOnExit>*/}
         {/*   <div id="Export_Map_Widget" style={styles.appWidgetDiv}>*/}
         {/*      <ExportMap.Render />*/}
         {/*   </div>*/}
         {/*</Zoom>*/}

         <Zoom in={legendVisible} timeout={delay} mountOnEnter unmountOnExit>
            <div id="Legend_Widget" style={styles.appWidgetDiv}>
               <Legend.Render />
            </div>
         </Zoom>

         <MapLayers.Render fadeIn={mapLayersVisible} />

         <Zoom in={mapThemesVisible} timeout={delay} mountOnEnter unmountOnExit>
            <div id="Map_Themes_Widget" style={styles.appWidgetDiv}>
               <MapThemes.Render />
            </div>
         </Zoom>

         <Zoom in={measureVisible} timeout={delay} mountOnEnter unmountOnExit>
            <div id="Measure_Widget" style={styles.appWidgetDiv}>
               <Measure.Render />
            </div>
         </Zoom>

         <Zoom in={printVisible} timeout={delay} mountOnEnter unmountOnExit>
            <div id="Print_Widget" style={styles.appWidgetDiv}>
               <PrintUI.Render />
            </div>
         </Zoom>

         {/*CUSTOM! Poway*/}
         <Zoom in={printAddressChangeVisible} timeout={delay} mountOnEnter unmountOnExit>
            <div id="Print_Address_Change_Widget" style={styles.appWidgetDiv}>
               <PrintAddressChangeUI.Render />
            </div>
         </Zoom>

         <Fade in={salesResultsVisible} timeout={delay} mountOnEnter unmountOnExit>
            <div id="Sales_Results_Widget" style={styles.appWidgetDiv}>
               <SalesResults.Render />
            </div>
         </Fade>

         <Zoom in={salesSearchVisible} timeout={delay} mountOnEnter unmountOnExit>
            <div id="Sales_Search_Widget" style={styles.appWidgetDiv}>
               <SalesSearch.Render />
            </div>
         </Zoom>

         <Fade in={searchResultsVisible} timeout={delay} mountOnEnter unmountOnExit>
            <div id="Search_Results_Widget" style={styles.appWidgetDiv}>
               <SearchResults.Render />
            </div>
         </Fade>

         <Zoom in={searchVisible} timeout={delay} mountOnEnter unmountOnExit>
            <div id="Quick_Search_Widget" style={styles.appWidgetDiv}>
               <QuickSearch.Render />
            </div>
         </Zoom>

         <Zoom in={selectOnMapVisible} timeout={delay} mountOnEnter unmountOnExit>
            <div id="Select_on_Map_Widget" style={styles.appWidgetDiv}>
               <SelectOnMap.Render />
            </div>
         </Zoom>

         <Zoom in={sketchVisible} timeout={delay} mountOnEnter unmountOnExit>
            <div id="Sketch_Widget" style={styles.appWidgetDiv}>
               <Sketch.Render />
            </div>
         </Zoom>

         <Zoom in={webMapsVisible} timeout={delay} mountOnEnter unmountOnExit>
            <div id="Web_Maps_Widget" style={styles.appWidgetDiv}>
               <WebMaps.Render />
            </div>
         </Zoom>

      </ThemeProvider>
   ); //end return.

} //end function.

//Create track button.
export function createTrackWidget(view: __esri.MapView | __esri.SceneView) {
   Util.logMsg("Creating Track widget");
   _track = new Track({ view: view, rotationEnabled: true });

   _track.when(function () {
      view.ui.add(_track, "top-right");

   }).catch(function (error: Error) { //Trap for errors.
      Util.errMsg("Failed to create Track widget.", error);
   });
}

//Create home button.
export function createHome(view: __esri.MapView | __esri.SceneView) {
   let extent = MainMap.mapExtentFull;

   const vp = new Viewpoint({
      targetGeometry: extent,
   });

   Util.logMsg('Creating Home button.');
   _home = new Home({ view: view, viewpoint: vp });
   view.ui.add(_home, "top-right");
}

//Create compass button for 2D only.
export function createCompass(view: __esri.MapView | __esri.SceneView) {
   if (MainMap.mapView && MainMap.view2D) {
      Util.logMsg('Creating compass button.');
      _compass = new Compass({ id: "compass_widget", view: view });
      view.ui.add(_compass, "top-right");
   }
}

//Create scalebar for 2D only.
export function createScalebar() {
   if (MainMap.mapView && MainMap.view2D) {
      removeScalebar();

      Util.logMsg('Creating scalebar.');
      _scaleBar = new ScaleBar({ view: MainMap.mapView, unit: "imperial", style: "ruler" });
   }
}

//Remove scalebar.
export function removeScalebar() {
   if (MainMap.mapView && _scaleBar) {
      Util.logMsg('Removing scalebar.');

      MainMap.mapView.ui.remove(_scaleBar);
      _scaleBar.destroy();
      _scaleBar = null;
   }
}

//Create basemap toggle on startup and for 2D/3D toggle.
export function createBasemapToggle() {
   //if (Settings.showBasemapToggle) {
   Util.logMsg('Creating basemap toggle.');

   //Compute next basemap.
   let nextBasemap: __esri.Basemap = null;

   if (basemapToggle) {
      nextBasemap = basemapToggle.nextBasemap;

   } else {
      for (const bm of MainMap.basemaps) {
         if (bm.id === Settings.basemapToggleLayerName) {
            nextBasemap = bm;
            break;
         }
      }
   }

   //Overwrite next basemap if not in same projection for 3D mode.
   if (!MainMap.view2D) {
      let sameProjection: boolean = false;
      if ((nextBasemap.spatialReference && nextBasemap.spatialReference.wkid) === MainMap.activeView.spatialReference.wkid) {
         sameProjection = true;
      }

      if (!sameProjection) {
         nextBasemap = MainMap.map.basemap;
      }
   }

   //Remove existing basemap toggle.
   if (basemapToggle) {
      Util.logMsg('Removing basemap toggle.');
      MainMap.activeView.ui.remove(basemapToggle);
   }

   if (nextBasemap) {
      basemapToggle = new BasemapToggle({ view: MainMap.activeView, nextBasemap: nextBasemap });

      //Wait for the map view to be ready before initializing the basemap toggle tooltip.
      reactiveUtils.whenOnce(() => !MainMap.mapView.updating).then(() => {
         setBasemapToggleTooltip(nextBasemap.title);
      });

      //Basemap toggle changed event.
      basemapToggle.watch("activeBasemap", function (newValue: __esri.Basemap, oldValue: __esri.Basemap) {
         let basemapName: string = newValue.id;
         ParcelSymbol.setParcelSymbol(basemapName);

         if (!Settings.basemapByScale.inProgress) {
            Settings.basemapByScale.active = false;
         }
         
         setBasemapToggleTooltip(oldValue.title); // Update the title tooltip on the basemap toggle widget.
      });
   }
}

//Set the tooltip for basemap toggle widget.
function setBasemapToggleTooltip(title: string) {
   const toggleButton: HTMLElement = document.querySelector('.esri-basemap-toggle calcite-button');
   if (toggleButton) {
      toggleButton.title = "Change basemap to " + title;
   }
}

//Set the basemap of the map view using the basemap toggle widget.
export function setBasemap(basemap: __esri.Basemap) {
   //Util.errMsg("Widgets: Setting basemap to: " + basemap.id);

   if (basemap) {
      basemap.loadAll().then(function () {
         basemapToggle.nextBasemap = basemap;
         basemapToggle.toggle();

      }).catch(function (error: Error) {
         Util.errMsg("Widgets.setBasemap - Unable to load basemap.", error);
      });
   }
}

//Set the next basemap (top thumbnail image) on the basemap toggle widget.
export function setNextBasemap(nextBasemap: __esri.Basemap) {
   //Util.errMsg("Widgets: Setting next basemap (top thumbnail) to: " + nextBasemap.id);
   basemapToggle.nextBasemap = nextBasemap;
}

//Create coordinate widget.
export function createCoordWidget() {
   import("@arcgis/core/widgets/CoordinateConversion").then(({ default: CoordinateConversion }) => {

      Util.logMsg('Creating coordinate widget.');

      //Remove existing coordinate widget.
      if (coordWidget) {
         Util.logMsg('Removing coordinate widget.');
         MainMap.activeView.ui.remove(coordWidget);
      }

      coordWidget = new CoordinateConversion({ view: MainMap.activeView });

      if (localStorage.Exists("ShowCoordinates")) {
         Settings.setShowCoordinates(localStorage.GetItem("ShowCoordinates") as boolean);
      }

      if (Settings.showCoordinates) {
         MainMap.activeView.ui.add(coordWidget, "bottom-left");
      }

   }).catch((error: Error) => {
      Util.errMsg('An error occurred while loading the coordinate conversion module:', error);
   });
}

//Disable capture mode on coordinate widget.
export function disableCoordWidgetCaptureMode() {
   if (!Settings.showCoordinates && coordWidget.mode === "capture") {
      coordWidget.mode = "live";
   }
}

//CUSTOM! Poway
//Toggle labels.
export function toggleLabels(showLabels: boolean) {
   let labelsLayer: any = null;
   labelsLayer = Util_App.getOperationalLayerById("Labels");

   if (labelsLayer) {
      if (showLabels) {
         //Turn labels group on
         labelsLayer.visible = true;
      } else {
         //Turn labels group off
         labelsLayer.visible = false;
      }
   }
}

//Set widget screen positions.
export function setPosition(expand?: boolean, collapse?: boolean) {
   const height: number = Util.windowHeight();
   const width: number = Util.windowWidth();

   //Get widget and scroll div elements and height.
   let widgetDiv: HTMLElement = null;
   let scrollDiv: HTMLElement = null;
   let toolDiv: HTMLElement = null; //Toolbar div.
   let toolHeaderHeight: number = 84; //Includes drawer toolbar and active tool title panel.

   if (MainMap.activeView && MainMap.activeView.type) {
      const toolName: string = DrawerMenu.curToolName;

      const widgetDivID = toolName.replace(" ", "_").replace(" ", "_") + "_Widget";
      widgetDiv = document.getElementById(widgetDivID);

      const scrollDivID = toolName.replace(" ", "_").replace(" ", "_") + "_Scroll";
      scrollDiv = document.getElementById(scrollDivID);

      toolDiv = document.getElementById("toolbarDiv");

      if (DrawerMenu.curToolName === "Search Results" && Search.layers.length > 0) {
         const lay: Search.iLayer = Search.layers[Search.activeLayerIndex];

         toolHeaderHeight += 59; //Add height of header buttons (Zoom all, Clear, More) and margins.

         if (Search.layers.length > 1) {
            toolHeaderHeight += 80; //Add height of layers dropdown.
         }

         if (lay.totRec > Settings.maxRecordCount) {
            toolHeaderHeight += 51; //Add height of paging buttons and margin.
         } else {
            toolHeaderHeight += 5; //Add spacing if paging buttons are missing.
         }

      } else if (DrawerMenu.curToolName === "Sales Results" && SalesSearch.layer.totRec > 0) {
         toolHeaderHeight += 116; //Add height of header buttons (Report, Clear, More) and margins.
      }
   }

   //Tools that are not full height.
   let tallTool: boolean = true;
   if (DrawerMenu.curToolName === "Compare Maps" || DrawerMenu.curToolName === "Export Map" ||
      DrawerMenu.curToolName === "Measure" || DrawerMenu.curToolName === "Sketch" ||
      DrawerMenu.curToolName === "Web Maps") {
      tallTool = false;
   }

   //Position all components on desktop monitor.
   if (!collapse && (expand || (width > Settings.smallScreenWidth))) {

      if (MainMap.mapView && MainMap.view2D) {
         MainMap.mapView.ui.move(_track, "top-right");
         MainMap.mapView.ui.move("zoom", "top-right");
         MainMap.mapView.ui.move(_home, "top-right");
         MainMap.mapView.ui.move(_compass, "top-right");
         MainMap.mapView.ui.add(PrevNextExtent.prevDiv, "top-right");
         MainMap.mapView.ui.add(PrevNextExtent.nextDiv, "top-right");
         MainMap.mapView.ui.padding = { top: 70, bottom: 15 };

      } else if (MainMap.sceneView) {
         MainMap.sceneView.ui.move(_track, "top-right");
         MainMap.sceneView.ui.move("zoom", "top-right");
         MainMap.sceneView.ui.move(_home, "top-right");
         MainMap.sceneView.ui.move("navigation-toggle", "top-right");
         MainMap.sceneView.ui.move("compass", "top-right");
         MainMap.sceneView.ui.padding = { top: 70 };
      }

      if (_scaleBar && MainMap.mapView && MainMap.view2D) {
         MainMap.mapView.ui.add(_scaleBar, "bottom-right");
      }

      //if (MainMap.activeView && Settings.showBasemapToggle) {
      if (MainMap.activeView) {
         MainMap.activeView.ui.add(basemapToggle, "bottom-left");
      }

      if (MainMap.activeView && Settings.showCoordinates) {
         if (DrawerMenu.curToolName) {
            if (width < (Settings.smallScreenWidth * 1.9)) {
               MainMap.activeView.ui.remove(coordWidget);
            } else {
               MainMap.activeView.ui.add(coordWidget, "bottom-left");
            }

         } else {
            if (width < (Settings.smallScreenWidth * 1.2)) {
               MainMap.activeView.ui.remove(coordWidget);
            } else {
               MainMap.activeView.ui.add(coordWidget, "bottom-left");
            }
         }

      } else if (MainMap.activeView) {
         MainMap.activeView.ui.remove(coordWidget);
      }

      if (MainMap.activeView && attribution && attribution.view.type !== MainMap.activeView.type) {
         MainMap.activeView.ui.remove(attribution); //Remove and re-add if 2D/3D mismatch.
         attribution = null;
      }

      if (!attribution && MainMap.activeView) {
         attribution = new Attribution({ view: MainMap.activeView });
         MainMap.activeView.ui.add(attribution);
      }

      if (toolDiv && toolDiv.style) {
         toolDiv.style.left = (Settings.leftPanelWidth + 3) + "px"; //Toolbar div.
      }

      if (DrawerMenu.curToolName) {
         if (widgetDiv) {
            widgetDiv.style.top = "37px";
            widgetDiv.style.maxHeight = (height + 1) + "px"; //Not sure if 1 is needed.

            if (scrollDiv) {
               const widgetBodyHeight: string = (height - toolHeaderHeight) + "px";
               scrollDiv.style.height = widgetBodyHeight;
            }
         }

         if (MainMap.activeView) {
            if (tallTool) {
               MainMap.activeView.padding = { left: Settings.leftPanelWidth, bottom: 0 };
            } else {
               MainMap.activeView.padding = { left: 0, bottom: 0 };
            }
         }

      } else {
         if (MainMap.activeView) {
            MainMap.activeView.padding = { left: 0, bottom: 0 };
         }
      }

   } else { //Small screens.
      if (MainMap.mapView && MainMap.view2D) {
         MainMap.mapView.ui.padding = { top: 45, left: 9, bottom: 15 };

         MainMap.mapView.ui.move(_track, "top-left");
         MainMap.mapView.ui.move("zoom", "top-left");
         MainMap.mapView.ui.move(_home, "top-left");
         MainMap.mapView.ui.move(_compass, "top-left");
         MainMap.mapView.ui.remove(PrevNextExtent.prevDiv);
         MainMap.mapView.ui.remove(PrevNextExtent.nextDiv);

         MainMap.mapView.ui.remove(_scaleBar);

      } else if (MainMap.sceneView) {
         MainMap.sceneView.ui.padding = { top: 45, left: 9 };

         MainMap.sceneView.ui.move(_track, "top-left");
         MainMap.sceneView.ui.move("zoom", "top-left");
         MainMap.sceneView.ui.move(_home, "top-left");
         MainMap.sceneView.ui.move("navigation-toggle", "top-left");
         MainMap.sceneView.ui.move("compass", "top-left");
      }

      if (MainMap.activeView) {
         MainMap.activeView.ui.remove(coordWidget);

         //if (Settings.showBasemapToggle) {
         //MainMap.activeView.ui.remove(basemapToggle);
         MainMap.activeView.ui.add(basemapToggle, "bottom-left");

         //}

         if (attribution) {
            MainMap.activeView.ui.remove(attribution);
            attribution = null;
         }
      }

      if (toolDiv && toolDiv.style) {
         toolDiv.style.left = (Settings.leftPanelWidth - 44) + "px"; //Toolbar div.
      }

      if (DrawerMenu.curToolName) {
         if (widgetDiv) {
            widgetDiv.style.top = (height / 2) + "px";
            widgetDiv.style.maxHeight = ((height / 2) + 30) + "px"; //Adjust as needed.

            if (scrollDiv) {
               const widgetBodyHeight: string = ((height / 2) - toolHeaderHeight + 30) + "px"; //Adjust as needed.
               scrollDiv.style.height = widgetBodyHeight;
            }
         }
         MainMap.activeView.padding = { left: 0, bottom: (height / 2) };

      } else {
         MainMap.activeView.padding = { left: 0, bottom: 0 };
      }
   }
}
